import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

interface Params {
    productId: string;
}
export const useProductQuery = ({ productId }: Params) => {
    const enterpriseId = useCurrentEnterpriseId();

    const query = useRepositorySuspenseQuery(
        'products',
        'getAll',
        {
            productIds: [productId],
            enterpriseIds: [enterpriseId],
        },
        {
            select: (result) => {
                const [product] = result.products || [];
                return product;
            },
        }
    );

    return query.data;
};
